var _rect, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 11.875,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1789_6430",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 14,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.999C26 12.6853 23.3137 9.99902 20 9.99902C16.6863 9.99902 14 12.6853 14 15.999V19.999C14 23.3127 16.6863 25.999 20 25.999C23.3137 25.999 26 23.3127 26 19.999V15.999Z",
    stroke: "white",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.999V29.999M16 29.999H24",
    stroke: "white",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.499C21.6569 19.499 23 18.1559 23 16.499C23 14.8422 21.6569 13.499 20 13.499C18.3431 13.499 17 14.8422 17 16.499C17 18.1559 18.3431 19.499 20 19.499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.499C20.5523 23.499 21 23.0513 21 22.499C21 21.9467 20.5523 21.499 20 21.499C19.4477 21.499 19 21.9467 19 22.499C19 23.0513 19.4477 23.499 20 23.499Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1789_6430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7.99976H32V31.9998H8V7.99976Z",
    fill: "#263077"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam);
export default __webpack_public_path__ + "static/media/cam.4953b36d5c7cf047f5cd3aed0bf1a0e2.svg";
export { ForwardRef as ReactComponent };